import { GridRow } from '@shared';
import { Task } from './task.model';

export class GridRowTasks extends GridRow(Task) {}
